import i18n from '../i18n';

// Fonction utilitaire pour obtenir les traductions
export const t = (key, params = {}) => {
  const lang = getCurrentLanguage();
  const keys = key.split('.');
  let value = translations[lang];

  for (const k of keys) {
    value = value?.[k];
  }

  // Si la valeur est undefined ou null, retourner la clé
  if (value === undefined || value === null) {
    console.warn(`Translation key "${key}" not found for language "${lang}"`);
    return key;
  }

  // Si la valeur est un objet, retourner la clé (erreur)
  if (typeof value === 'object' && value !== null) {
    console.error(`Translation key "${key}" returns an object. Please use a more specific key.`);
    return key;
  }

  // Remplacer les paramètres comme {{count}}
  if (typeof value === 'string' && params) {
    Object.keys(params).forEach(param => {
      value = value.replace(`{{${param}}}`, params[param]);
    });
  }

  return value || key;
};

// Fonction pour changer la langue
export const changeLanguage = (lang) => {
  try {
    i18n.changeLanguage(lang);
    return true;
  } catch (error) {
    console.error('Erreur lors du changement de langue:', error);
    return false;
  }
};

// Fonction pour obtenir la langue actuelle
export const getCurrentLanguage = () => {
  const storedLang = localStorage.getItem('i18nextLng');
  if (storedLang && (storedLang === 'fr' || storedLang === 'en')) {
    return storedLang;
  }
  const browserLang = navigator.language.split('-')[0];
  return browserLang === 'en' ? 'en' : 'fr';
};

// Fonction pour vérifier si i18n est initialisé
export const isI18nReady = () => {
  return i18n.isInitialized;
};

// Actions
export const actions = {
  water: 'Eau, Hygiène et Assainissement',
  health: 'Santé et Nutrition',
  social: 'Sensibilisation et Éducation',
  environment: 'Environnement et Climat',
  life: 'Amélioration des Conditions de Vie'
};

export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      discover: 'Découvrir',
      about: 'À propos',
      mission: 'Mission',
      history: 'Historique',
      team: 'Équipe',
      status: 'Statuts',
      actions: 'Nos Actions',
      news: 'Actualités',
      documents: 'Documents',
      projects: 'Projets',
      project_health: 'Santé et Sécurité',
      project_water: 'Eau et Assainissement',
      project_environment: 'Environnement',
      project_education: 'AHB Education',
      development: 'Développement',
      publications: 'Publications',
      membership: 'Adhésion',
      contacts: 'Contacts',
      donate: 'Faire un don',
      search: 'Rechercher...',
      topBanner: 'Ensemble pour un avenir meilleur'
    },
    hero: {
      learnMore: 'En savoir plus',
      discover: 'Découvrir nos projets',
      slide: 'Slide',
      error: 'Erreur de chargement',
      loadingError: 'Erreur de chargement',
      retry: 'Réessayer',
      noSlides: 'Aucun contenu disponible',
      slidesComingSoon: 'Les contenus arrivent bientôt',
      displayError: 'Erreur d\'affichage',
      cannotLoadSlide: 'Impossible de charger le contenu'
    },
    footer: {
      sectorsTitle: 'Nos Secteurs',
      sector1: 'Cadre de vie',
      sector2: 'Eau et assainissement',
      sector3: 'Santé et sécurité alimentaire',
      sector4: 'Sensibilisation et éducation',
      sector5: "Protection de l'environnement",
      
      topicsTitle: 'Nos Thématiques',
      topic1: 'Environnement et Climat',
      topic2: 'Cadre de Vie',
      topic3: 'Développement Durable',
      topic4: 'Égalité des Genres',
      
      micrositesTitle: 'Nos Microsites',
      microsite1: 'Projets en Cours',
      microsite2: 'Rapports Annuels',
      microsite3: 'Agrément',
      
      connectTitle: 'Nous Suivre',
      
      resourcesTitle: 'Ressources',
      resource1: 'Documentation',
      resource2: 'Publications',
      resource3: 'Médias',
      resource4: 'Outils',
      
      legal1: 'Mentions Légales',
      legal2: 'Politique de Confidentialité',
      legal3: 'Conditions d\'Utilisation',
      legal4: 'Plan du Site',
      legal5: 'Contact',
      legal6: 'Accessibilité',
      legal7: 'Cookies',
      
      scrollToTop: 'Retour en haut',
      copyright: '© 2024 Action-Humanitaire Bénin. Tous droits réservés.'
    },
    partners: {
      title: 'Nos Partenaires',
      subtitle: 'Ensemble pour un impact durable',
      loadingError: 'Erreur lors du chargement des partenaires'
    },
    infocus: {
      title: 'En Focus',
      subtitle: 'Découvrez nos actions phares',
      joinMission: 'Rejoindre Notre Mission',
      contactUs: 'Nous Contacter',
      readMore: 'Lire la suite',
      learnMore: 'En savoir plus',
      discover: 'Découvrir',
      viewProject: 'Voir le projet'
    },
    projects: {
      title: 'Nos Projets',
      subtitle: 'Des initiatives qui changent des vies',
      viewAll: 'Voir tous les projets',
      inProgress: 'En cours',
      completed: 'Terminé',
      upcoming: 'À venir',
      learnMore: 'En savoir plus',
      discover: 'Découvrir',
      readMore: 'Lire la suite',
      viewProject: 'Voir le projet',
      seeMore: 'Voir plus',
      exploreProject: 'Explorer le projet'
    },
    strategy: {
      title: 'Nos Stratégies',
      subtitle: 'Découvrez nos approches innovantes',
      readMore: 'En savoir plus',
      learnMore: 'En savoir plus',
      noDescription: 'Aucune description disponible',
      loadingError: 'Erreur de chargement',
      retry: 'Réessayer',
      noStrategies: 'Aucune stratégie disponible',
      noStrategiesDesc: 'Les stratégies seront bientôt disponibles',
      recentArticlesTitle: 'Articles Récents',
      recentArticlesSubtitle: 'Découvrez nos dernières publications',
      noArticles: 'Aucun article disponible',
      noArticlesDesc: 'Les articles seront bientôt disponibles'
    },
    news: {
      title: 'Actualités',
      subtitle: 'Restez informés de nos actions',
      searchPlaceholder: 'Rechercher un article...',
      allCategories: 'Toutes les catégories',
      sortLatest: 'Plus récents',
      sortOldest: 'Plus anciens',
      sortTitle: 'Par titre',
      resultsCount: '{{count}} articles trouvés',
      forQuery: 'pour',
      inCategory: 'dans',
      noArticlesFound: 'Aucun article trouvé',
      noArticlesDesc: 'Aucun article ne correspond à votre recherche',
      clearFilters: 'Effacer les filtres',
      readMore: 'Lire la suite',
      noDescription: 'Aucune description disponible',
      previous: 'Précédent',
      next: 'Suivant'
    },
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Nous sommes à votre écoute pour répondre à vos questions',
      coordinates: {
        title: 'Nos Coordonnées',
        address: {
          title: 'Adresse',
          street: 'Rue 1200 de Danto',
          city: 'Porto-Novo, République du Bénin'
        },
        phone: {
          title: 'Téléphone',
          number: '+229 01 55 07 81 81'
        },
        email: {
          title: 'Email',
          address: 'contact@ahbenin.org'
        },
        hours: {
          title: 'Horaires d\'ouverture',
          weekdays: 'Lundi - Vendredi',
          weekdaysTime: '8h00 - 17h00',
          saturday: 'Samedi',
          saturdayTime: '9h00 - 13h00'
        },
        map: {
          title: 'Notre Localisation'
        }
      },
      form: {
        title: 'Envoyez-nous un message',
        name: {
          label: 'Nom complet',
          placeholder: 'Votre nom complet'
        },
        email: {
          label: 'Adresse email',
          placeholder: 'votre.email@exemple.com'
        },
        subject: {
          label: 'Objet',
          placeholder: 'L\'objet de votre message'
        },
        message: {
          label: 'Message',
          placeholder: 'Écrivez votre message ici...'
        },
        submit: 'Envoyer le message'
      },
      healthProgram: 'Programme Santé',
      international: 'International',
      humanitarian: 'Humanitaire',
      ethical: 'Éthique',
      ourValues: 'Nos Valeurs',
      keyFact: 'Fait clé',
      contextFact: 'De nombreux patients n\'ont pas accès aux informations nécessaires pour orienter leurs soins.',
      waterProgram: 'Programme Eau',
      sustainable: 'Durable',
      inclusive: 'Inclusif',
      local: 'Local',
      environmentProgram: 'Programme Environnement',
      ecological: 'Écologique',
      community: 'Communautaire'
    },
    development: {
      hero: {
        subtitle: 'International',
        title: "Facilitation d'investissements structurants – Afrique de l'Ouest",
        description: "Dans le cadre de sa mission de promotion d'un développement économique inclusif et durable, ACTION-HUMANITAIRE BÉNIN (AHB) déploie une initiative stratégique dédiée à la facilitation d'investissements structurants en Afrique de l'Ouest."
      },
      countries: {
        title: "Pays couverts prioritairement"
      },
      mission: {
        text: "Cette initiative couvre prioritairement les pays suivants : Bénin, Côte d'Ivoire, Sénégal, Ghana et Nigeria. Elle vise à identifier, structurer et accompagner des entreprises à fort potentiel, porteuses de projets d'investissement significatifs, notamment dans les secteurs industriel et agro-industriel."
      },
      approach: {
        title: "Une approche orientée impact et structuration",
        identification: "L'identification d'entreprises présentant un potentiel de croissance avéré",
        analysis: "L'analyse de projets d'investissement à forte valeur ajoutée",
        accompaniment: "L'accompagnement à la structuration financière et stratégique",
        facilitation: "La facilitation de mises en relation ciblées avec des partenaires financiers internationaux"
      },
      target: {
        title: "Entreprises ciblées",
        structured: "Structurées et légalement constituées",
        industrial: "Opérant dans les secteurs industriels ou agro-industriel",
        investment: "Disposant de projets d'investissement d'envergure",
        growth: "Orientées vers la croissance, la transformation ou l'export"
      },
      areas: {
        title: "Domaines d'intervention prioritaires",
        manufacturing: "Industrie manufacturière (matériaux, transformation, production)",
        agro: "Agro-industrie (transformation de produits agricoles)",
        industrialization: "Industrialisation et chaînes de valeur",
        modernization: "Modernisation des capacités de production",
        export: "Développement de marchés à l'export"
      },
      role: {
        title: "Rôle de AHB",
        detection: "La détection et la qualification d'opportunités d'investissement",
        accompaniment: "L'accompagnement des entreprises dans la préparation de leurs projets",
        connection: "La mise en relation avec des partenaires financiers adaptés",
        followup: "Le suivi des interactions dans une logique de structuration durable"
      },
      commitment: {
        title: "Engagement",
        competitiveness: "Renforcer la compétitivité des entreprises locales",
        industrialization: "Stimuler l'industrialisation",
        financing: "Favoriser l'accès à des financements structurants",
        growth: "Soutenir une croissance économique durable et inclusive"
      },
      contact: {
        title: "Contact",
        description: "Les entreprises intéressées ou souhaitant obtenir davantage d'informations sont invitées à prendre contact avec AHB :"
      },
      notice: {
        title: "Mention importante",
        text: "ACTION-HUMANITAIRE BÉNIN (AHB) agit en tant que facilitateur indépendant. Les décisions de financement relèvent exclusivement des institutions financières partenaires."
      },
      cta: {
        button: "Nous contacter"
      }
    },
    sante: {
      program: {
        hero: {
          subtitle: 'Programme International',
          title: 'Programme d\'Accès aux Soins Spécialisés Internationaux',
          description: 'Un programme humanitaire dédié à l\'information, l\'orientation et l\'accompagnement des patients vers des solutions de soins spécialisés adaptées à leurs besoins.'
        },
        context: {
          title: 'Contexte',
          content: 'De nombreux patients n\'ont pas accès aux informations nécessaires pour orienter leurs soins. Face à des pathologies complexes ou nécessitant des traitements spécialisés, ils se retrouvent souvent démunis, sans savoir vers qui se tourner ni quelles options s\'offrent à eux. Cette situation peut entraîner des retards de prise en charge, une errance médicale et une aggravation de leur état de santé.'
        },
        objective: {
          title: 'Objectif du programme',
          content: 'Le Programme d\'Accès aux Soins Spécialisés Internationaux vise à combler ce vide informationnel en offrant aux patients un accompagnement gratuit, transparent et éthique. Il s\'agit de leur fournir les informations nécessaires pour comprendre leur situation médicale, connaître les options disponibles et, s\'ils le souhaitent, être orientés vers des structures de soins spécialisées, y compris à l\'international.'
        },
        axes: {
          title: 'Axes d\'intervention',
          axis1: {
            title: 'Sensibilisation et information',
            item1: 'Diffusion d\'affiches éducatives dans les centres de santé et espaces publics',
            item2: 'Partage de contenus de sensibilisation via les réseaux sociaux et médias locaux',
            item3: 'Campagnes d\'information sur les pathologies majeures et les options de traitement disponibles'
          },
          axis2: {
            title: 'Orientation des patients',
            item1: 'Identification des besoins médicaux spécifiques de chaque patient',
            item2: 'Explication claire des options disponibles, sans obligation ni pression',
            item3: 'Mise à disposition de supports pédagogiques (vidéos, guides) pour faciliter la compréhension'
          },
          axis3: {
            title: 'Mise en relation',
            item1: 'Connexion volontaire des patients avec des structures spécialisées adaptées à leur pathologie',
            item2: 'Accès à des avis médicaux externes (second avis) pour éclairer les décisions',
            item3: 'Facilitation des démarches administratives et organisationnelles si le patient le souhaite'
          },
          axis4: {
            title: 'Accompagnement',
            item1: 'Suivi des patients tout au long du processus de prise en charge',
            item2: 'Assistance dans la compréhension des procédures médicales et administratives',
            item3: 'Orientation post-traitement si nécessaire pour assurer la continuité des soins'
          }
        },
        partnership: {
          title: 'Partenariat technique',
          content: 'Ce programme bénéficie d\'un partenariat technique avec DivinHeal, une plateforme spécialisée dans la facilitation de l\'accès aux soins médicaux internationaux. Grâce à ce partenariat, les patients peuvent, s\'ils le souhaitent, accéder à un réseau d\'hôpitaux et de spécialistes reconnus à l\'international, tout en conservant leur liberté de choix et leur autonomie décisionnelle.'
        },
        ethical: {
          title: 'Approche éthique',
          principle1: 'Respect du libre choix du patient : aucune décision n\'est imposée',
          principle2: 'Aucune obligation de recours aux services proposés',
          principle3: 'Absence de toute pression ou influence commerciale',
          principle4: 'Transparence dans les informations communiquées',
          principle5: 'Protection des données personnelles et confidentialité médicale'
        },
        socialFund: {
          title: 'Fonds d\'impact social',
          intro: 'Une partie des ressources générées par ce programme est réinvestie dans un fonds d\'impact social destiné à :',
          item1: 'Appuyer les patients vulnérables qui ne peuvent pas accéder aux soins faute de moyens',
          item2: 'Soutenir les cas sociaux identifiés par les structures de santé locales',
          item3: 'Renforcer les actions locales de santé publique et de prévention'
        },
        results: {
          title: 'Résultats attendus',
          result1: 'Amélioration de l\'accès à l\'information médicale pour les populations vulnérables',
          result2: 'Orientation plus rapide et plus efficace vers des solutions de soins adaptées',
          result3: 'Réduction des situations d\'errance médicale et des retards de prise en charge',
          result4: 'Renforcement de la confiance des populations dans le système de santé'
        },
        vision: {
          title: 'Vision',
          content: 'À travers ce programme, ACTION-HUMANITAIRE BÉNIN (AHB) ambitionne de contribuer à un accès plus équitable aux soins de santé, en plaçant l\'information, la transparence et le respect du patient au cœur de son action. L\'objectif est de permettre à chaque personne, quelle que soit sa situation, de prendre des décisions éclairées concernant sa santé.'
        },
        cta: {
          button: 'Nous contacter'
        }
      }
    },
    eau: {
      program: {
        hero: {
          subtitle: 'High 5',
          title: 'Eau et Assainissement',
          description: 'L\'eau est un droit fondamental, pas un privilège. Dans le cadre de ses axes stratégiques "High 5", l\'ONG Action-Humanitaire Bénin œuvre pour garantir un accès équitable à l\'eau potable et à des conditions d\'assainissement dignes pour les communautés vulnérables.'
        },
        context: {
          title: 'Contexte',
          content: 'Dans plusieurs zones du Bénin, l\'accès à l\'eau potable et à des infrastructures sanitaires adéquates demeure un défi majeur. Cette situation entraîne des risques sanitaires élevés, notamment des maladies hydriques, et affecte considérablement la qualité de vie des populations. AHB intervient pour apporter des solutions durables, inclusives et adaptées aux réalités locales.'
        },
        objectives: {
          title: 'Objectifs du projet',
          obj1: 'Garantir l\'accès à une eau potable sécurisée',
          obj2: 'Améliorer les conditions d\'hygiène et d\'assainissement',
          obj3: 'Réduire les maladies liées à l\'eau',
          obj4: 'Renforcer les capacités des communautés locales'
        },
        actions: {
          title: 'Nos actions',
          action1: 'Construction et réhabilitation de forages et puits',
          action2: 'Installation de latrines et infrastructures sanitaires',
          action3: 'Organisation de campagnes de sensibilisation',
          action4: 'Formation de comités locaux de gestion de l\'eau',
          action5: 'Suivi et maintenance des installations'
        },
        indicators: {
          title: 'Indicateurs clés',
          ind1: '01 forage réalisé',
          ind2: '02 blocs sanitaires installés',
          ind3: '200+ bénéficiaires directs',
          ind4: '01 campagne de sensibilisation menée'
        },
        partnerships: {
          title: 'Partenariats',
          content: 'AHB collabore avec les autorités locales, les organisations communautaires et des partenaires techniques et financiers pour maximiser l\'impact et assurer la durabilité des projets.'
        },
        impact: {
          title: 'Impact',
          impact1: 'Les populations accèdent à une eau potable sécurisée',
          impact2: 'Les conditions sanitaires sont améliorées',
          impact3: 'Les risques de maladies diminuent',
          impact4: 'Les communautés deviennent autonomes'
        },
        project: {
          location: 'Calavi, Bénin',
          status: 'Terminé'
        },
        cta: {
          title: 'Agissez avec nous',
          description: 'Vous souhaitez soutenir ou collaborer sur ce projet ? Rejoignez-nous pour améliorer durablement les conditions de vie des populations.',
          button: 'Nous contacter',
          partner: 'Devenir partenaire',
          support: 'Soutenir ce projet'
        }
      }
    },
    environnement: {
      program: {
        hero: {
          subtitle: 'Environnement & Climat',
          title: 'Programme de Sensibilisation et de Protection Environnementale & Sanitaire',
          description: 'Dans un contexte marqué par les effets du changement climatique et la dégradation de l\'environnement, AHB initie un programme de sensibilisation communautaire visant à promouvoir des comportements responsables et durables.'
        },
        context: {
          title: 'Contexte et justification',
          content: 'Les populations locales sont exposées à de nombreux dangers : pollution de l\'air et des déchets, mauvaises pratiques d\'hygiène, exposition aux substances nocives, et risques liés à la circulation routière. Face à ces défis, AHB a initié un programme de sensibilisation communautaire.'
        },
        objectives: {
          title: 'Objectifs du projet',
          general: 'Contribuer à la protection de l\'environnement et à la réduction des risques sanitaires à travers des actions de sensibilisation et de prévention.',
          obj1: 'Promouvoir les bonnes pratiques d\'hygiène et de sécurité',
          obj2: 'Réduire les impacts environnementaux des déchets',
          obj3: 'Sensibiliser aux dangers liés aux produits toxiques et polluants',
          obj4: 'Encourager l\'utilisation des équipements de protection',
          obj5: 'Prévenir les accidents et risques sanitaires'
        },
        activities: {
          title: 'Activités réalisées',
          cat1: {
            title: 'Sensibilisation sanitaire et sécurité',
            item1: 'Sensibilisation des personnels de stations-service à l\'utilisation de masques de protection',
            item2: 'Promotion des équipements de protection individuelle (EPI)',
            item3: 'Sensibilisation à la démarche QHSE (Qualité, Hygiène, Sécurité, Environnement)'
          },
          cat2: {
            title: 'Hygiène et gestion des déchets',
            item1: 'Sensibilisation à l\'hygiène individuelle et collective',
            item2: 'Formation sur la gestion des ordures ménagères',
            item3: 'Tri des déchets plastiques pour la protection de l\'environnement'
          },
          cat3: {
            title: 'Santé environnementale',
            item1: 'Sensibilisation des travailleurs de friperie sur les risques (cancer du poumon, inhalation)',
            item2: 'Promotion de l\'utilisation de masques lors du tri des vêtements usagés',
            item3: 'Sensibilisation aux dangers des produits importés et émissions de gaz'
          },
          cat4: {
            title: 'Protection et sécurité routière',
            item1: 'Sensibilisation des usagers de la route',
            item2: 'Promotion du port du casque et du masque',
            item3: 'Prévention des accidents de circulation'
          },
          cat5: {
            title: 'Protection de l\'environnement',
            item1: 'Actions de sauvegarde environnementale',
            item2: 'Sensibilisation à la réduction de la pollution'
          }
        },
        impact: {
          title: 'Impact du projet',
          impact1: 'Amélioration des comportements en matière d\'hygiène',
          impact2: 'Réduction des risques sanitaires',
          impact3: 'Sensibilisation accrue sur les enjeux environnementaux',
          impact4: 'Adoption progressive des équipements de protection',
          impact5: 'Contribution à la lutte contre la pollution'
        },
        partnerships: {
          title: 'Partenariats',
          intro: 'Ce projet peut être développé en collaboration avec :',
          partner1: 'Autorités locales',
          partner2: 'Entreprises (stations-service, recyclage)',
          partner3: 'ONG environnementales',
          partner4: 'Institutions internationales'
        },
        alignment: {
          title: 'Alignement international',
          intro: 'Ce projet contribue à :',
          contrib1: 'Protection de l\'environnement',
          contrib2: 'Santé publique',
          contrib3: 'Gestion durable des déchets',
          contrib4: 'Sécurité routière',
          odd: 'Aligné avec les Objectifs de Développement Durable (ODD) : ODD 3 (Santé), ODD 6 (Eau & hygiène), ODD 11 (Villes durables), ODD 13 (Climat)'
        },
        cta: {
          title: 'Agissez avec nous pour protéger notre environnement',
          description: 'AHB invite partenaires, institutions et entreprises à soutenir et accompagner ce programme à fort impact.',
          button: 'Nous contacter'
        }
      }
    }
  },
  en: {
    nav: {
      home: 'Home',
      discover: 'Discover',
      about: 'About',
      mission: 'Mission',
      history: 'History',
      team: 'Team',
      status: 'Statutes',
      actions: 'Our Actions',
      news: 'News',
      documents: 'Documents',
      projects: 'Projects',
      project_health: 'Health and Safety',
      project_water: 'Water and Sanitation',
      project_environment: 'Environment',
      project_education: 'AHB Education',
      development: 'Development',
      publications: 'Publications',
      membership: 'Membership',
      contacts: 'Contacts',
      donate: 'Donate',
      search: 'Search...',
      topBanner: 'Together for a better future'
    },
    hero: {
      learnMore: 'Learn more',
      discover: 'Discover our projects',
      slide: 'Slide',
      error: 'Loading error',
      loadingError: 'Loading error',
      retry: 'Retry',
      noSlides: 'No content available',
      slidesComingSoon: 'Content coming soon',
      displayError: 'Display error',
      cannotLoadSlide: 'Cannot load content'
    },
    footer: {
      sectorsTitle: 'Our Sectors',
      sector1: 'Living conditions',
      sector2: 'Water and sanitation',
      sector3: 'Health and food security',
      sector4: 'Awareness and education',
      sector5: 'Environmental protection',
      
      topicsTitle: 'Our Topics',
      topic1: 'Environment and Climate',
      topic2: 'Living Conditions',
      topic3: 'Sustainable Development',
      topic4: 'Gender Equality',
      
      micrositesTitle: 'Our Microsites',
      microsite1: 'Ongoing Projects',
      microsite2: 'Annual Reports',
      microsite3: 'Accreditation',
      
      connectTitle: 'Follow Us',
      
      resourcesTitle: 'Resources',
      resource1: 'Documentation',
      resource2: 'Publications',
      resource3: 'Media',
      resource4: 'Tools',
      
      legal1: 'Legal Notice',
      legal2: 'Privacy Policy',
      legal3: 'Terms of Use',
      legal4: 'Site Map',
      legal5: 'Contact',
      legal6: 'Accessibility',
      legal7: 'Cookies',
      
      scrollToTop: 'Back to top',
      copyright: '© 2024 Action-Humanitaire Bénin. All rights reserved.'
    },
    partners: {
      title: 'Our Partners',
      subtitle: 'Together for sustainable impact',
      loadingError: 'Error loading partners'
    },
    infocus: {
      title: 'In Focus',
      subtitle: 'Discover our flagship actions',
      joinMission: 'Join Our Mission',
      contactUs: 'Contact Us',
      readMore: 'Read more',
      learnMore: 'Learn more',
      discover: 'Discover',
      viewProject: 'View project'
    },
    projects: {
      title: 'Our Projects',
      subtitle: 'Initiatives that change lives',
      viewAll: 'View all projects',
      inProgress: 'In Progress',
      completed: 'Completed',
      upcoming: 'Upcoming',
      learnMore: 'Learn more',
      discover: 'Discover',
      readMore: 'Read more',
      viewProject: 'View project',
      seeMore: 'See more',
      exploreProject: 'Explore project'
    },
    strategy: {
      title: 'Our Strategies',
      subtitle: 'Discover our innovative approaches',
      readMore: 'Learn more',
      learnMore: 'Learn more',
      noDescription: 'No description available',
      loadingError: 'Loading error',
      retry: 'Retry',
      noStrategies: 'No strategies available',
      noStrategiesDesc: 'Strategies will be available soon',
      recentArticlesTitle: 'Recent Articles',
      recentArticlesSubtitle: 'Discover our latest publications',
      noArticles: 'No articles available',
      noArticlesDesc: 'Articles will be available soon'
    },
    news: {
      title: 'News',
      subtitle: 'Stay informed about our actions',
      searchPlaceholder: 'Search for an article...',
      allCategories: 'All categories',
      sortLatest: 'Latest',
      sortOldest: 'Oldest',
      sortTitle: 'By title',
      resultsCount: '{{count}} articles found',
      forQuery: 'for',
      inCategory: 'in',
      noArticlesFound: 'No articles found',
      noArticlesDesc: 'No articles match your search',
      clearFilters: 'Clear filters',
      readMore: 'Read more',
      noDescription: 'No description available',
      previous: 'Previous',
      next: 'Next'
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'We are here to answer your questions',
      coordinates: {
        title: 'Our Contact Information',
        address: {
          title: 'Address',
          street: 'Rue 1200 de Danto',
          city: 'Porto-Novo, Republic of Benin'
        },
        phone: {
          title: 'Phone',
          number: '+229 XX XX XX XX'
        },
        email: {
          title: 'Email',
          address: 'contact@ahbenin.org'
        },
        hours: {
          title: 'Opening Hours',
          weekdays: 'Monday - Friday',
          weekdaysTime: '8:00 AM - 5:00 PM',
          saturday: 'Saturday',
          saturdayTime: '9:00 AM - 1:00 PM'
        },
        map: {
          title: 'Our Location'
        }
      },
      form: {
        title: 'Send us a message',
        name: {
          label: 'Full name',
          placeholder: 'Your full name'
        },
        email: {
          label: 'Email address',
          placeholder: 'your.email@example.com'
        },
        subject: {
          label: 'Subject',
          placeholder: 'The subject of your message'
        },
        message: {
          label: 'Message',
          placeholder: 'Write your message here...'
        },
        submit: 'Send message'
      },
      healthProgram: 'Health Program',
      international: 'International',
      humanitarian: 'Humanitarian',
      ethical: 'Ethical',
      ourValues: 'Our Values',
      keyFact: 'Key Fact',
      contextFact: 'Many patients do not have access to the information needed to guide their care.',
      waterProgram: 'Water Program',
      sustainable: 'Sustainable',
      inclusive: 'Inclusive',
      local: 'Local',
      environmentProgram: 'Environment Program',
      ecological: 'Ecological',
      community: 'Community'
    },
    development: {
      hero: {
        subtitle: 'International',
        title: "Structuring Investment Facilitation – West Africa",
        description: "As part of its mission to promote inclusive and sustainable economic development, ACTION-HUMANITAIRE BÉNIN (AHB) deploys a strategic initiative dedicated to facilitating structuring investments in West Africa."
      },
      countries: {
        title: "Priority Coverage Countries"
      },
      mission: {
        text: "This initiative primarily covers the following countries: Benin, Côte d'Ivoire, Senegal, Ghana, and Nigeria. It aims to identify, structure, and support high-potential companies with significant investment projects, particularly in the industrial and agro-industrial sectors."
      },
      approach: {
        title: "An Impact-Oriented and Structuring Approach",
        identification: "Identification of companies with proven growth potential",
        analysis: "Analysis of high value-added investment projects",
        accompaniment: "Support for financial and strategic structuring",
        facilitation: "Facilitation of targeted connections with international financial partners"
      },
      target: {
        title: "Target Companies",
        structured: "Structured and legally constituted",
        industrial: "Operating in industrial or agro-industrial sectors",
        investment: "With large-scale investment projects",
        growth: "Oriented towards growth, transformation, or export"
      },
      areas: {
        title: "Priority Intervention Areas",
        manufacturing: "Manufacturing industry (materials, transformation, production)",
        agro: "Agro-industry (agricultural product transformation)",
        industrialization: "Industrialization and value chains",
        modernization: "Modernization of production capacities",
        export: "Export market development"
      },
      role: {
        title: "AHB's Role",
        detection: "Detection and qualification of investment opportunities",
        accompaniment: "Support for companies in preparing their projects",
        connection: "Connection with appropriate financial partners",
        followup: "Follow-up of interactions with a sustainable structuring logic"
      },
      commitment: {
        title: "Commitment",
        competitiveness: "Strengthen the competitiveness of local companies",
        industrialization: "Stimulate industrialization",
        financing: "Facilitate access to structuring financing",
        growth: "Support sustainable and inclusive economic growth"
      },
      contact: {
        title: "Contact",
        description: "Interested companies or those seeking more information are invited to contact AHB:"
      },
      notice: {
        title: "Important Notice",
        text: "ACTION-HUMANITAIRE BÉNIN (AHB) acts as an independent facilitator. Financing decisions are the exclusive responsibility of partner financial institutions."
      },
      cta: {
        button: "Contact us"
      }
    },
    sante: {
      program: {
        hero: {
          subtitle: 'International Program',
          title: 'International Specialized Healthcare Access Program',
          description: 'A humanitarian program dedicated to informing, guiding, and supporting patients toward specialized care solutions tailored to their needs.'
        },
        context: {
          title: 'Context',
          content: 'Many patients lack access to the information needed to guide their care. Faced with complex pathologies or requiring specialized treatments, they often find themselves helpless, not knowing where to turn or what options are available. This situation can lead to delays in care, medical wandering, and worsening of their health condition.'
        },
        objective: {
          title: 'Program Objective',
          content: 'The International Specialized Healthcare Access Program aims to fill this information gap by offering patients free, transparent, and ethical support. It provides them with the necessary information to understand their medical situation, know the available options, and, if they wish, be directed to specialized care facilities, including internationally.'
        },
        axes: {
          title: 'Intervention Areas',
          axis1: {
            title: 'Awareness and Information',
            item1: 'Distribution of educational posters in health centers and public spaces',
            item2: 'Sharing awareness content via social networks and local media',
            item3: 'Information campaigns on major pathologies and available treatment options'
          },
          axis2: {
            title: 'Patient Guidance',
            item1: 'Identification of specific medical needs for each patient',
            item2: 'Clear explanation of available options, without obligation or pressure',
            item3: 'Provision of educational materials (videos, guides) to facilitate understanding'
          },
          axis3: {
            title: 'Connection',
            item1: 'Voluntary connection of patients with specialized facilities suited to their pathology',
            item2: 'Access to external medical opinions (second opinion) to inform decisions',
            item3: 'Facilitation of administrative and organizational procedures if the patient wishes'
          },
          axis4: {
            title: 'Support',
            item1: 'Patient follow-up throughout the care process',
            item2: 'Assistance in understanding medical and administrative procedures',
            item3: 'Post-treatment guidance if necessary to ensure continuity of care'
          }
        },
        partnership: {
          title: 'Technical Partnership',
          content: 'This program benefits from a technical partnership with DivinHeal, a platform specialized in facilitating access to international medical care. Through this partnership, patients can, if they wish, access a network of internationally recognized hospitals and specialists, while maintaining their freedom of choice and decision-making autonomy.'
        },
        ethical: {
          title: 'Ethical Approach',
          principle1: 'Respect for patient\'s free choice: no decision is imposed',
          principle2: 'No obligation to use the proposed services',
          principle3: 'Absence of any commercial pressure or influence',
          principle4: 'Transparency in the information communicated',
          principle5: 'Protection of personal data and medical confidentiality'
        },
        socialFund: {
          title: 'Social Impact Fund',
          intro: 'Part of the resources generated by this program is reinvested in a social impact fund intended to:',
          item1: 'Support vulnerable patients who cannot access care due to lack of means',
          item2: 'Support social cases identified by local health facilities',
          item3: 'Strengthen local public health and prevention actions'
        },
        results: {
          title: 'Expected Results',
          result1: 'Improved access to medical information for vulnerable populations',
          result2: 'Faster and more effective guidance toward appropriate care solutions',
          result3: 'Reduction of medical wandering situations and care delays',
          result4: 'Strengthening of population trust in the healthcare system'
        },
        vision: {
          title: 'Vision',
          content: 'Through this program, ACTION-HUMANITAIRE BÉNIN (AHB) aims to contribute to more equitable access to healthcare, placing information, transparency, and respect for the patient at the heart of its action. The goal is to enable every person, regardless of their situation, to make informed decisions about their health.'
        },
        cta: {
          button: 'Contact us'
        }
      }
    },
    eau: {
      program: {
        hero: {
          subtitle: 'High 5',
          title: 'Water and Sanitation',
          description: 'Water is a fundamental right, not a privilege. As part of its "High 5" strategic axes, the NGO Action-Humanitaire Bénin works to ensure equitable access to drinking water and dignified sanitation conditions for vulnerable communities.'
        },
        context: {
          title: 'Context',
          content: 'In several areas of Benin, access to drinking water and adequate sanitary infrastructure remains a major challenge. This situation leads to high health risks, particularly waterborne diseases, and significantly affects the quality of life of populations. AHB intervenes to provide sustainable, inclusive solutions adapted to local realities.'
        },
        objectives: {
          title: 'Project objectives',
          obj1: 'Ensure access to safe drinking water',
          obj2: 'Improve hygiene and sanitation conditions',
          obj3: 'Reduce water-related diseases',
          obj4: 'Strengthen local community capacities'
        },
        actions: {
          title: 'Our actions',
          action1: 'Construction and rehabilitation of boreholes and wells',
          action2: 'Installation of latrines and sanitary infrastructure',
          action3: 'Organization of awareness campaigns',
          action4: 'Training of local water management committees',
          action5: 'Monitoring and maintenance of installations'
        },
        indicators: {
          title: 'Key indicators',
          ind1: '01 borehole completed',
          ind2: '02 sanitary blocks installed',
          ind3: '200+ direct beneficiaries',
          ind4: '01 awareness campaign conducted'
        },
        partnerships: {
          title: 'Partnerships',
          content: 'AHB collaborates with local authorities, community organizations, and technical and financial partners to maximize impact and ensure project sustainability.'
        },
        impact: {
          title: 'Impact',
          impact1: 'Populations access safe drinking water',
          impact2: 'Sanitary conditions are improved',
          impact3: 'Disease risks decrease',
          impact4: 'Communities become autonomous'
        },
        project: {
          location: 'Calavi, Benin',
          status: 'Completed'
        },
        cta: {
          title: 'Act with us',
          description: 'Would you like to support or collaborate on this project? Join us to sustainably improve living conditions for populations.',
          button: 'Contact us',
          partner: 'Become a partner',
          support: 'Support this project'
        }
      }
    },
    environnement: {
      program: {
        hero: {
          subtitle: 'Environment & Climate',
          title: 'Environmental & Health Awareness and Protection Program',
          description: 'In a context marked by the effects of climate change and environmental degradation, AHB initiates a community awareness program aimed at promoting responsible and sustainable behaviors.'
        },
        context: {
          title: 'Context and justification',
          content: 'Local populations are exposed to many dangers: air and waste pollution, poor hygiene practices, exposure to harmful substances, and road traffic risks. Faced with these challenges, AHB has initiated a community awareness program.'
        },
        objectives: {
          title: 'Project objectives',
          general: 'Contribute to environmental protection and reduction of health risks through awareness and prevention actions.',
          obj1: 'Promote good hygiene and safety practices',
          obj2: 'Reduce environmental impacts of waste',
          obj3: 'Raise awareness about dangers related to toxic and polluting products',
          obj4: 'Encourage the use of protective equipment',
          obj5: 'Prevent accidents and health risks'
        },
        activities: {
          title: 'Activities carried out',
          cat1: {
            title: 'Health and safety awareness',
            item1: 'Awareness of gas station staff on the use of protective masks',
            item2: 'Promotion of personal protective equipment (PPE)',
            item3: 'Awareness of QHSE approach (Quality, Hygiene, Safety, Environment)'
          },
          cat2: {
            title: 'Hygiene and waste management',
            item1: 'Awareness of individual and collective hygiene',
            item2: 'Training on household waste management',
            item3: 'Sorting of plastic waste for environmental protection'
          },
          cat3: {
            title: 'Environmental health',
            item1: 'Awareness of second-hand clothing workers about risks (lung cancer, inhalation)',
            item2: 'Promotion of mask use when sorting used clothing',
            item3: 'Awareness of dangers of imported products and gas emissions'
          },
          cat4: {
            title: 'Road protection and safety',
            item1: 'Awareness of road users',
            item2: 'Promotion of helmet and mask wearing',
            item3: 'Prevention of traffic accidents'
          },
          cat5: {
            title: 'Environmental protection',
            item1: 'Environmental safeguarding actions',
            item2: 'Awareness of pollution reduction'
          }
        },
        impact: {
          title: 'Project impact',
          impact1: 'Improvement of hygiene behaviors',
          impact2: 'Reduction of health risks',
          impact3: 'Increased awareness of environmental issues',
          impact4: 'Progressive adoption of protective equipment',
          impact5: 'Contribution to the fight against pollution'
        },
        partnerships: {
          title: 'Partnerships',
          intro: 'This project can be developed in collaboration with:',
          partner1: 'Local authorities',
          partner2: 'Companies (gas stations, recycling)',
          partner3: 'Environmental NGOs',
          partner4: 'International institutions'
        },
        alignment: {
          title: 'International alignment',
          intro: 'This project contributes to:',
          contrib1: 'Environmental protection',
          contrib2: 'Public health',
          contrib3: 'Sustainable waste management',
          contrib4: 'Road safety',
          odd: 'Aligned with Sustainable Development Goals (SDGs): SDG 3 (Health), SDG 6 (Water & hygiene), SDG 11 (Sustainable cities), SDG 13 (Climate)'
        },
        cta: {
          title: 'Act with us to protect our environment',
          description: 'AHB invites partners, institutions and companies to support and accompany this high-impact program.',
          button: 'Contact us'
        }
      }
    }
  }
};
